import { PRODUCT_TYPE_GIFTCARD, PRODUCT_TYPE_GROUPED } from '@bluheadless/ui-logic/src/constants'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { ScalapayWidget } from '../scalapay'

const InstallmentsPrice = ({ ...props }) => {
	const {
		sales: {
			payments: {
				scalapay: {
					enabled: scalapayEnabled,
					product: {
						enabled: scalapayEnabledProduct,
						size,
						logoSize,
						logoAlignment,
						logoColor,
						priceColor,
						hideLogo,
						hidePrice,
					},
				},
			},
		},
	} = useConfig()

	const [
		{
			product: { type },
			prices,
			selectedOptions,
		},
	] = useProductContext()

	return type !== PRODUCT_TYPE_GROUPED && scalapayEnabled && scalapayEnabledProduct ? (
		<div {...props}>
			<ScalapayWidget
				purchaseAmount={
					type === PRODUCT_TYPE_GIFTCARD
						? selectedOptions.amount || selectedOptions.openAmount || prices.final
						: prices.final
				}
				size={size}
				logoSize={logoSize}
				logoAlignment={logoAlignment}
				logoColor={logoColor}
				priceColor={priceColor}
				hideLogo={hideLogo}
				hidePrice={hidePrice}
			/>
		</div>
	) : null
}

InstallmentsPrice.propTypes = {}

export default InstallmentsPrice
